import React, {Component} from 'react';
import {Avatar, Button, List, message} from 'antd';
import NewManager from '../new';
import EditManager from '../edit';
import {Loading} from '../../../components/loading';
import ManagerRepo from '../../../repository/manager';
import './list.scss';

class ManagerList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      managers: [],

      showNew: false,
      showEditManager: false,
    }
  }

  fetchManagers = () => {
    if (!this.state.loading) {
      return;
    }

    ManagerRepo.fetch(this.props.business.id).then(
      result => {
        this.setState({
          managers: result.data.managers || [],
          loading: false,
        })
      },
      error => {
        message.error("Error fetching managers");
        console.log(error.response);
      },
    );
  };

  title = () => {
    return <p className='section-title'>
      Managers
      <span className="fa-pull-right"><Button type="link" onClick={() => this.setState({showNew: true})}>Add manager</Button></span>
    </p>
  };

  loading = () => {
    return (
      <Loading>{this.title()}</Loading>
    )
  };

  render() {
    const {business} = this.props;

    if (business.id) {
      this.fetchManagers();
    }

    if (this.state.loading) {
      return this.loading();
    }

    return (
      <>
        {this.title()}

        <NewManager
          business={business}
          visible={this.state.showNew}
          setVisible={visible => {
            this.setState({showNew: visible, loading: false})
          }}
        />

        <EditManager
          business={business}
          manager={this.state.manager}
          visible={this.state.showEditManager}
          setVisible={visible => this.setState({showEditManager: visible, loading: false})}
        />

        <List
          dataSource={this.state.managers}
          bordered
          renderItem={item => (
            <List.Item key={item.id} actions={[<Button onClick={() => {
              this.setState({manager: item, showEditManager: true})
            }}>edit</Button>]}>
              <List.Item.Meta
                avatar={
                  item.picture ? <Avatar src={item.picture}/>
                    : <Avatar src="https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png"/>
                }
                title={item.email}
                description={item.legacy_user ? item.legacy_user.name.alias : item.id}
              />
            </List.Item>
          )}
        />
      </>
    );
  }
}

export default ManagerList;